import { SVGProps, Ref, forwardRef } from 'react';

export const ArchiveboxArrowFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M1.667 3.8C.208 3.8 0 3.594 0 2.15S.208.5 1.667.5h12.666C15.792.5 16 .706 16 2.15s-.208 1.65-1.667 1.65z"
                        fill="currentColor"
                    />
                    <path
                        d="M1.333 5.2v5.636h.002c.02 1.471.254 2.53.785 3.264h4.145c.984 0 1.766-.916 1.766-2 0-1.082-.782-1.999-1.766-1.999H5.202l1.3 1.3-.99.99-2.99-2.99 2.99-2.99.99.99-1.3 1.3h1.063c1.949 0 3.166 1.75 3.166 3.4 0 1.642-1.207 3.384-3.14 3.399h3.484c3.59 0 4.836-1.172 4.886-4.664h.002V5.2z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ArchiveboxArrowFilledSize16Glyph.displayName = 'ArchiveboxArrowFilledSize16Glyph';
